import React, { useCallback } from 'react';
import { Redirect, useParams, useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import SubjectsPanel, { useSubjectsPanel } from '@ts-core/components/SubjectsPanel';
import SubjectPageHeader from '@ts-core/components/SubjectPageHeader';
import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';

import useSubjectTabs from '../../hooks/useSubjectTabs';
import { useSubjects, useSubject } from '../../hooks';

const SubjectPage = () => {
  const history = useHistory();
  const { courseId, subjectId, tabSlug } = useParams();
  const { subjects, loading } = useSubjects({ courseId });
  const { subject } = useSubject({ courseId, subjectId });
  const { tabs, activePage, onGoToTab, defaultTab } = useSubjectTabs();
  const { Component } = activePage || {};

  const navigateToSubject = useCallback(
    (targetSubject) => {
      history.push(`/${courseId}/subjects/${targetSubject._id}/${tabSlug}`);
    },
    [history, courseId, tabSlug]
  );

  const subjectPanelProps = useSubjectsPanel({
    subjects,
    loading,
    selectedSubjectId: subjectId,
    showSelectedMark: true,
    onSelectLeafSubject: navigateToSubject,
  });

  if (!tabSlug || !subject) {
    return <div />;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ToMainMenuButton noMargin />
        </Grid>
        <Grid item xs={12} md={4}>
          <SubjectsPanel {...subjectPanelProps} />
        </Grid>
        <Grid item xs={12} md={8}>
          <SubjectPageHeader title={subject?.name} tabs={tabs} activeTab={activePage?.tab} onGoToTab={onGoToTab} />
          {Component && <Component />}
        </Grid>
      </Grid>
      {!activePage && <Redirect to={defaultTab.slug} />}
    </>
  );
};

export default SubjectPage;
